import client from '../../libs/client';

export default class PaymentGateway {
    createParticipantPaymentDetail = async (participantId, paymentDetail) => {
        const res = await client.post(
            `/participants/${participantId}/payments/creditor`,
            paymentDetail
        );
        return res;
    };

    createParticipantMandatesDetails = async (
        participantId,
        mandatesDetails
    ) => {
        const producerIds = Object.keys(mandatesDetails);
        if (producerIds.length > 0) {
            return Promise.all(
                producerIds.map(async (producerId) => {
                    const res = await client.post(
                        `/participants/${producerId}/payments/mandates`,
                        {
                            ...mandatesDetails[producerId],
                            participantId,
                        }
                    );
                    return res;
                })
            );
        }
    };
    createBillingEntityPaymentDetail = async (
        billingEntityId,
        paymentDetail
    ) => {
        const res = await client.post(
            `/payments/creditors/by-billing-entities/${billingEntityId}`,
            paymentDetail
        );
        return res;
    };

    createBillingEntityMandate = async (billingEntityId, mandateDetails) => {
        const res = await client.post(
            `/payments/mandates/by-billing-entity/${billingEntityId}`,
            {
                ...mandateDetails,
            }
        );
        return res;
    };

    createMultipleMandatesForProducer = async (producerId, mandatesDetails) => {
        const { data: results } = await client.post(
            `/payments/mandates/import/by-creditor/${producerId}`,
            {
                mandates: mandatesDetails,
            }
        );

        return results;
    };

    createMultipleMandatesForBillingEntity = async (
        billingEntityId,
        mandatesDetails
    ) => {
        const { data: results } = await client.post(
            `/payments/mandates/import/by-billing-entity/${billingEntityId}`,
            {
                mandates: mandatesDetails,
            }
        );

        return results;
    };

    downloadSepaFile = async (
        producerId,
        invoicesIds,
        billingPeriodEnd,
        producerName
    ) => {
        const { data } = await client.get(
            `/participants/${producerId}/payments/sepa?invoicesIds=${invoicesIds.join(
                ','
            )}`
        );
        const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
        const href = URL.createObjectURL(blob);
        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        const fileName = `${producerName}_${billingPeriodEnd}_sepa.xml`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    };

    downloadBillingEntitySepaFile = async (
        billingEntityId,
        invoicesIds,
        billingEntityName,
        billingPeriodEnd
    ) => {
        const { data } = await client.get(
            `/payments/sepa/by-billing-entity/${billingEntityId}?invoicesIds=${invoicesIds.join(
                ','
            )}`
        );
        const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
        const href = URL.createObjectURL(blob);
        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        const fileName = `${billingEntityName}_${billingPeriodEnd}_sepa.xml`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    };

    getMultipleSepaDocumentsUrls = async (producers, billingPeriodEnd) => {
        const producersChunks = this.splitArrayIntoChunks(producers);
        const contentsWithTitles = [];
        for (let i = 0; i < producersChunks.length; i++) {
            const responses = await Promise.all(
                producersChunks[i].map(
                    async ({ producerId, producerName, invoicesIds }) => {
                        const { data } = await client.get(
                            `/participants/${producerId}/payments/sepa?invoicesIds=${invoicesIds.join(
                                ','
                            )}`
                        );
                        const fileName = `${producerName}_${billingPeriodEnd}_sepa.xml`;
                        return {
                            title: fileName,
                            content: data,
                        };
                    }
                )
            );
            contentsWithTitles.push(...responses);
        }
        return contentsWithTitles;
    };

    getCreditorsDetailsByProducers = async (producersIds) => {
        const { data: creditors } = await client.get(
            `/payments/creditors/by-producers?participantsIds=${producersIds.join(
                ','
            )}`
        );
        return creditors;
    };

    getCreditorsDetailsByBillingEntities = async (billingEntityIds) => {
        const { data: creditors } = await client.get(
            `/payments/creditors/by-billing-entities?billingEntityIds=${billingEntityIds.join(
                ','
            )}`
        );
        return creditors;
    };

    getProducerMandates = async (producerId) => {
        const { data: mandates } = await client.get(
            `/payments/mandates/by-creditor/${producerId}`
        );
        return mandates;
    };

    getBillingEntityMandates = async (billingEntityId) => {
        const { data: mandates } = await client.get(
            `/payments/mandates/by-billing-entity/${billingEntityId}`
        );
        return mandates;
    };
    splitArrayIntoChunks = (elements) => {
        const CHUNK_LENGTH = 10;
        let chunks = [];
        for (let i = 0; i < elements.length; i += CHUNK_LENGTH) {
            chunks.push(elements.slice(i, i + CHUNK_LENGTH));
        }
        return chunks;
    };
}
